module.exports = __webpack_public_path__ + "static/img/smcc.1fa3217.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/patrocinio/smcc.jpg
// module id = zkx5
// module chunks = 1